export class AxError {
  constructor(public message: string, public type: string) {}
  toString = () => this.message;
}
